export default class Break {
	constructor(id, name, description, cron, duration, vehicles_id) {
		this.id = id || 0;
		this.name = name || "";
		this.cron = cron || "";
		this.duration = duration || "12:00:00";
		this.description = description || "";
		this.vehicles_id = vehicles_id || [];
	}
}
